export default __webpack_public_path__ + "static/media/vote-table.8278dcd9.png";